import '../../../core/components/app-root/AppRoot.css';
import './ResizeSeparator.css';
export var handleFlexWidthVariable = '--_dt-split-handle-ew';
export var handleTrack = '_151k20o1-3-15-1';
export var inlineHandleTrack = '_151k20o2-3-15-1 _151k20o1-3-15-1';
export var separator = '_151k20o0-3-15-1';